import React, { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import { useGlobalStore } from 'store/global/globalStore';
import { CategoriesSelection } from '../categories/categories-selection';
import { ReportSelection } from '../report-selection/report-selection';
import SelectProducer from '../selectProducer/selectProducer';
import { ReportLoader } from '../report-selection/report-loader';
import './index.scss';
import { GenerateReportLink } from '../../../api/reports';
import { useQuery } from '@tanstack/react-query';
//import { useUser } from '../../../context/UserContext';
//import { Button } from '@mui/material';
//import PowerBi from '../powerBi/powerBi';
import ProducerIDsDropdown from '../../../components/Global/ProducerIDsDropdown/ProducerIDsDropdown';

const urlParams = new URLSearchParams(window.location.search);

function Index() {
  const [overrideProducerID, setOverrideProducerID] = useState(urlParams.get('overrideProducerID'));
  const [npnUpdateDetails, setNpnUpdateDetails] = useState(null);
  const [categoryID, setCategoryID] = useState(undefined);
  const [reportPath, setReportPath] = useState(undefined);
  const [reportParams, setReportParams] = useState(undefined);
  const [selectProducerOpen, setSelectProducerOpen] = useState(false);
  //const [division, setDivision] = useState(null);
  const [reportServerID, setReportServerID] = useState(undefined);
  const [viewerReport, setReportSelector] = useState(null);
  const [powerBIDatasetID, setPowerBIDatasetID] = useState(null);
  const [powerBIGroupID, setPowerBIGroupID] = useState(null);
  const [powerBIReportID, setPowerBIReportID] = useState(null);
  const [powerBIWorkspaceID, setPowerBIWorkspaceID] = useState(null);
  const [reportDescription, setReportDescription] = useState('');
  //const user = useUser();
  const producerID = useGlobalStore((state) => state.producerID);
  const [reportID, setReportID] = useState(null);
  const [path, setPath] = useState(null);
  const domain = useGlobalStore((state) => state.domain);

  const generateReportLinkQuery = useQuery({
    queryKey: ['generateReportLink', reportID, overrideProducerID],
    queryFn: () =>
      GenerateReportLink({
        Path: path,
        ServerID: reportServerID,
        ReportID: reportID,
        ViewProducer: overrideProducerID,
      })(),
    enabled: reportID != null && reportServerID !== undefined && path != null,
  });

  useEffect(() => {
    if (generateReportLinkQuery.isSuccess && generateReportLinkQuery.data) {
      setReportPath(generateReportLinkQuery.data.postBackUrl);
      setReportSelector(null);
    }
  }, [generateReportLinkQuery.isSuccess, generateReportLinkQuery.data]);

  useEffect(() => {
    if (generateReportLinkQuery.isError) {
      setReportPath(null);
      setReportSelector(path);
    }
  }, [generateReportLinkQuery.isError, path]);

  /* useEffect(() => {
       fetch('/home/GetProducerClaim', {
         crossDomain: true,
         method: 'POST',
         headers: {
           Accept: 'application/json',
           'Content-Type': 'application/json',
         },
       }).then((res) => res.json())
         .then((data) => {
           setDivision(data.division);
         });
     }, []);*/

  const setCategoryCallback = (category) => {
    setCategoryID(category);
  };

  const setReportCallback = (
    path,
    serverID,
    rptID,
    rptDesc,
    params,
    powerBIDatasetID,
    powerBIGroupID,
    powerBIReportID,
    powerBIWorkspaceID
  ) => {
    if (path.substring(0, 1) === '/') {
      setPath(path);
      setReportID(rptID);
      setReportDescription(rptDesc);

      /*const body = {
              Path: path, ServerID: serverID, ReportID: rptID, ViewProducer: overrideProducerID,
            };
            const options = {
              crossDomain: true,
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(body),
            };
      
            setReportDescription(rptDesc);
      
            fetch('/Reports/generateReportLink', options)
              .then((res) => res.json()).then((data) => {
                setReportPath(data.url);
                setReportSelector(null);
              });*/
    } else {
      setReportPath(null);
      setReportSelector(path);
    }

    setReportParams(params);
    setReportServerID(serverID);
    if (powerBIDatasetID) {
      setPowerBIDatasetID(powerBIDatasetID);
    }
    if (powerBIGroupID) {
      setPowerBIGroupID(powerBIGroupID);
    }
    if (powerBIReportID) {
      setPowerBIReportID(powerBIReportID);
    }
    if (powerBIWorkspaceID) {
      setPowerBIWorkspaceID(powerBIWorkspaceID);
    }
  };

  //const parsedParams = params ? [JSON.parse(params)] : null;
  //useEffect(() => {
  //    if (parsedParams != null && parsedParams.length > 0) {
  //        if (parsedParams[0].ParameterName == "NPN" && user != null && user.npnID != null && user.npnID.length > 1) {
  //            handleUpdateParamsStateNPN();
  //        }
  //    }
  //}, [onClickNPNCallback])

  return (
    <div className="mt-5">
      <div className="row page-heading">
        <h3 style={{ marginBottom: '0px' }}>Reports</h3>
      </div>
      <Paper square>
        <div className="d-flex w-100 justify-content-around pt-3">
          {!selectProducerOpen && (
            <>
              <div className="w-25">
                {/* Passing props and prod id to each call to avoid recomp on each render.
                            won't be needed when using middleware calls w/ JWT cookie.  */}
                <CategoriesSelection
                  setCategory={setCategoryCallback}
                  domain={domain}
                  producerID={producerID}
                />
              </div>
              <div className="w-25">
                <ReportSelection
                  setReport={setReportCallback}
                  categoryID={categoryID}
                  domain={domain}
                  producerID={producerID}
                />
              </div>
              {reportPath !== null && reportPath !== 'undefined' && (
                <div className="w-25">
                  <ProducerIDsDropdown
                    setProducerID={(id) => {
                      setOverrideProducerID(id);
                    }}
                    variant="standard"
                  />
                </div>
              )}
            </>
          )}
        </div>
        {reportParams && JSON.parse(reportParams).ParameterName === 'NPN' && (
          <div className="d-flex justify-content-center" style={{ margin: '0.5em 1em 0 1em' }}>
            <SelectProducer
              setNpnUpdateDetails={setNpnUpdateDetails}
              setSelectProducerOpen={setSelectProducerOpen}
              useLabel={true}
              useIcon={true}
            />
          </div>
        )}
        <div className="row">
          <div className="col-12 report-selection" style={{ paddingTop: '3px' }}>
            {reportDescription}
          </div>
        </div>
        <div className="row report-view" style={{ height: '100vh' }}>
          {reportPath !== null && reportPath !== 'undefined' && (
            <iframe
              title="powerbi-iframe"
              src={reportPath}
              style={{ width: '100%', height: '100%', border: 'none' }}
            />
          )}
          {(reportParams || viewerReport === 'OnePagerLegacy') && (
            <ReportLoader
              npnUpdateDetails={npnUpdateDetails}
              view={viewerReport}
              params={reportParams}
              powerBIDatasetID={powerBIDatasetID}
              powerBIGroupID={powerBIGroupID}
              powerBIReportID={powerBIReportID}
              powerBIWorkspaceID={powerBIWorkspaceID}
            />
          )}
        </div>
      </Paper>
    </div>
  );
}

export { Index };
